export const createBase64Image = (avatar: string, format: "jpeg" | "png" = "jpeg") =>
  `data:image/${format};base64,${avatar}`;

export const getFaviconUrl = (urlOrDomain: string | null, size: 16 | 32 = 32): string | null => {
  if (!urlOrDomain) return null;
  let domain: string;
  try {
    domain = new URL(urlOrDomain).hostname;
  } catch {
    domain = urlOrDomain.replace(/^www\./, "");
  }
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=${size}`;
};
